<template>
    <ButtonComp
        button-type="Secondary"
        class="ms-3"
        icon="fa-refresh"
        :title="$tm(props.title ?? 'signup.reloadisonen')"
        @click="handleIsonenUpdates"
    >
        <div class="d-flex flex-row flex-nowrap gap-2">
            <span
                v-if="props.text"
                v-html="$tm(props.text)"
            ></span>
            <DateComp
                :value="Event?.Setup?.ISonenLastImport ?? null"
                format="DAYTIME"
                :monospace="false"
            />
        </div>
    </ButtonComp>
</template>
<script lang="ts" setup>
import { ButtonComp, DateComp } from '@/components';
import UpdateExternalDataView from '@/components/ExternalData/UpdateExternalDataView.vue';
import { useTaskLoader } from '@/composeables';
import { EventDao } from '@/dao';
import { $tm } from '@/locize';
import { ExternalDatasourceEvent } from '@/objects/generated';
import { useEventCommonStoreRef, useToastStore } from '@/stores';
import { ThreadSleep } from '@/utilities/utils';
import { useDialog } from '@/composeables';

const { Event } = useEventCommonStoreRef();

const props = defineProps<{
    /**
     * The text to show in the button
     */
    text?: string;

    /**
     * The title to show on hover
     */
    title?: string;
}>();

const { AddLoader: ISonenAddLoader, LoadState: ISonenLoadState, ClearLoaders: ISonenClearLoaders } = useTaskLoader();
const { AddLoader: ISonenAddLoader2, LoadState: ISonenLoadState2 } = useTaskLoader();

const handleIsonenUpdates = async () => {
    const event = ExternalDatasourceEvent.FromJsValues({
        Key: Event.value?.Setup?.ISonenID ?? null,
    });

    if (!event.Key) return;

    const dialog = await useDialog().SaveCancel({
        title: 'signup.isonenupdates',
        body: UpdateExternalDataView,
        saveCallback: async (params) => {
            const dialogInstance = params.dialogBodyComponentInstanceRef;
            if (!dialogInstance) {
                return false;
            }
            ISonenClearLoaders();
            await ISonenAddLoader(async () => {
                const request = dialogInstance.GetUpdateEventRequest();
                if (!request) return;

                if (request.Contestants.length == 0) {
                    useToastStore().addInfo($tm('general.no_rows_selected'));
                    params.stopDialogFromClosing();
                    return;
                }

                try {
                    await EventDao.UpdateEvent(request, Event.value!.ID);

                    dialogInstance.SetSaveSuccess();

                    // We wait a bit to show the success message (?)
                    await ThreadSleep(2000);

                    dialog.closeDialog();
                } catch (ex) {
                    console.error('Failed to update event with isonen data', ex);
                }
            }, '');
            return false;
        },
        componentProps: {
            item: event,
            loadState: ISonenLoadState.value,
            addLoader: ISonenAddLoader,
            clearLoaders: ISonenClearLoaders,
        },
        savestate: ISonenLoadState2.value,
        options: {
            Size: 'xxl',
        },
    });
};
</script>
